<!-- Page header -->
<div class="hh-page-header">
  <button pButton type="button" class="p-button-text p-button-sm" (click)="goBack()">
    <i class="pi pi-arrow-left"></i>
  </button>
  <span class="hh-page-title">Process Bins</span>
  <div class="flex items-center gap-1">
    <i *ngIf="showRefreshIcon" class="pi pi-sync pi-spin text-sm opacity-70"></i>
    <button pButton type="button" class="p-button-text p-button-sm" title="Refresh" (click)="loadBins()">
      <i class="pi pi-refresh"></i>
    </button>
  </div>
</div>

<div *ngIf="isPageReady" class="p-3 flex flex-col gap-3 h-full">
  <!-- Filters -->
  <div class="flex items-center gap-3">
    <p-select
      [options]="addonStations"
      [(ngModel)]="selectedStationId"
      optionLabel="name"
      optionValue="id"
      placeholder="Station"
      (onChange)="onFilterChanged()"
      class="flex-1"
      [style]="{ width: '100%' }">
      <ng-template pTemplate="selectedItem" let-selected>
        {{ selected?.name || '[ All ]' }}
      </ng-template>
      <ng-template pTemplate="item" let-station>
        {{ station.name }}
      </ng-template>
    </p-select>

    <div class="flex items-center gap-2">
      <p-checkbox
        [(ngModel)]="showClosedBins"
        [binary]="true"
        (onChange)="onFilterChanged()">
      </p-checkbox>
      <label class="text-sm">Closed</label>
    </div>
  </div>

  <!-- Bin count -->
  <div class="text-sm text-gray-500">
    {{ addonBins.length }} bin{{ addonBins.length !== 1 ? 's' : '' }}
  </div>

  <!-- Bins list -->
  <div class="flex flex-col gap-3 overflow-y-auto flex-1">
    <div *ngFor="let bin of addonBins" class="hh-card flex flex-col gap-2">
      <div class="flex justify-between items-start">
        <div>
          <span class="text-lg font-bold">Bin {{ bin.id }}</span>
          <span class="ml-2 text-sm opacity-70">{{ bin.account?.accountName }}</span>
        </div>
        <span class="hh-badge" [ngClass]="getStationStatusBadgeClass(bin)">
          {{ bin.addonBinStatus?.name }}
        </span>
      </div>

      <div class="grid grid-cols-2 gap-x-3 gap-y-1">
        <div *ngIf="bin.pendingAddonStation">
          <div class="hh-card-label">Pending Station</div>
          <div class="hh-card-value">{{ bin.pendingAddonStation.name }}</div>
        </div>
        <div *ngIf="bin.currentAddonStation">
          <div class="hh-card-label">Current Station</div>
          <div class="hh-card-value">{{ bin.currentAddonStation.name }}</div>
        </div>
        <div *ngIf="bin.priorityOrder">
          <div class="hh-card-label">Priority</div>
          <div class="hh-card-value">{{ bin.priorityOrder }}</div>
        </div>
        <div *ngIf="bin.currentAddonBinStationStatus">
          <div class="hh-card-label">Station Status</div>
          <div class="hh-card-value">{{ bin.currentAddonBinStationStatus.name }}</div>
        </div>
      </div>

      <button class="hh-btn hh-btn-primary mt-1" (click)="processBin(bin)">
        Process
      </button>
    </div>

    <div *ngIf="addonBins.length === 0" class="text-center py-8 opacity-50">
      No bins found
    </div>
  </div>
</div>
